import portalApi from './portalApi';

const portalCaseService = {
  getCases: () => portalApi.get('/portal/cases'),
  getCaseDetail: (caseId) => portalApi.get(`/portal/cases/${caseId}`),
  getCaseDocuments: (caseId) => portalApi.get(`/portal/cases/${caseId}/documents`),
  downloadDocument: (documentId) =>
    portalApi.get(`/portal/documents/${documentId}/download`, { responseType: 'blob' }),
};

export default portalCaseService;
